/**
 * Default docking layout configuration for flexlayout-react.
 *
 * Two-column layout:
 * - Left: DAG Panel (provenance graph)
 * - Right: Data Explorer (AG Grid + Charts) on top, Plot Viewer on bottom
 */

export interface PanelDef {
  id: string;
  name: string;
  component: string;
}

export const ALL_PANELS: PanelDef[] = [
  { id: "dag", name: "Provenance DAG", component: "dag" },
  { id: "data-explorer", name: "Data Explorer", component: "data-explorer" },
  { id: "plot-viewer", name: "Plot Viewer", component: "plot-viewer" },
  { id: "reproducibility", name: "Reproducibility", component: "reproducibility" },
  { id: "flow360-viewer", name: "Flow360 Viewer", component: "flow360-viewer" },
  { id: "fork-sweep", name: "Solver Cockpit", component: "fork-sweep" },
  { id: "plot-builder", name: "Plot Builder", component: "plot-builder" },
  { id: "saved-plots", name: "Saved Plots", component: "saved-plots" },
  { id: "version-history", name: "Version History", component: "version-history" },
  { id: "diff-view", name: "Diff View", component: "diff-view" },
  { id: "history", name: "History", component: "history" },
  { id: "configuration", name: "Aircraft & References", component: "configuration" },
];

export const defaultLayout = {
  global: {
    tabEnableClose: true,
    tabSetEnableMaximize: true,
    tabSetEnableDrop: true,
    borderBarSize: 40,
  },
  borders: [],
  layout: {
    type: "row",
    weight: 100,
    children: [
      {
        type: "tabset",
        weight: 40,
        children: [
          {
            type: "tab",
            id: "dag",
            name: "Provenance DAG",
            component: "dag",
          },
        ],
      },
      {
        type: "row",
        weight: 60,
        children: [
          {
            type: "tabset",
            weight: 60,
            children: [
              {
                type: "tab",
                id: "data-explorer",
                name: "Data Explorer",
                component: "data-explorer",
              },
            ],
          },
          {
            type: "tabset",
            weight: 40,
            children: [
              {
                type: "tab",
                id: "plot-builder",
                name: "Plot Builder",
                component: "plot-builder",
              },
              {
                type: "tab",
                id: "saved-plots",
                name: "Saved Plots",
                component: "saved-plots",
              },
              {
                type: "tab",
                id: "plot-viewer",
                name: "Plot Viewer",
                component: "plot-viewer",
              },
              {
                type: "tab",
                id: "reproducibility",
                name: "Reproducibility",
                component: "reproducibility",
              },
            ],
          },
        ],
      },
    ],
  },
};
